"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const getWindowItem_1 = tslib_1.__importDefault(require("./getWindowItem"));
function default_1(state, windowId) {
    const window = (0, getWindowItem_1.default)(state, windowId);
    return window ? window.isVisible : false;
}
exports.default = default_1;
//# sourceMappingURL=isVisibleWindow.js.map